import Api from 'src/api/Base'

class GetExportsMasterPsa extends Api {
  requestUrl = `/api/Export/MasterPsa?startDate=${this.getParams().startDate}&endDate=${
    this.getParams().endDate
  }`
}

export default GetExportsMasterPsa
